(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collectVideos(root) {
    var scope = root || document;
    return scope.querySelectorAll('.editorial-campaign video, video[data-editorial-autoplay]');
  }

  function prepVideo(video) {
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    if (video.hasAttribute('autoplay') || video.dataset.editorialAutoplay === 'true') {
      video.dataset.editorialAutoplay = 'true';
    }
  }

  function readyVideos(root) {
    var videos = collectVideos(root);
    if (!videos.length) return;

    videos.forEach(prepVideo);

    if (reduced) {
      videos.forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        if (video.preload === 'none') video.preload = 'metadata';
        if (video.dataset.editorialAutoplay === 'true') video.play().catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'metadata';
            if (video.dataset.editorialAutoplay === 'true') {
              video.muted = true;
              video.playsInline = true;
              video.play().catch(function () {});
            }
          } else if (!video.closest('.editorial-hero')) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.15 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function init(root) {
    readyVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
